import { ILoggerIntegration, LoggerConfigOptions } from "../loggingService";

// this library is imported/configured in static/i/head_js.inc
declare var Rollbar: any;

class RollbarLogger implements ILoggerIntegration {

    private available: boolean;
    constructor() {
        this.available = !!Rollbar;
    }

    configure(options: LoggerConfigOptions) {
        Rollbar.configure({
            payload: {
                person: {
                    id: options.id
                },
                context : {
                    company: options.company,
                    rights: options.rights
                }
            }
        });
    }

    error(...args: any[]) {
        Rollbar.error.apply(Rollbar, args);
    }

    warning(...args: any[]) {
        Rollbar.warning.apply(Rollbar, args);
    }

    info(...args: any[]) {
        Rollbar.info.apply(Rollbar, args);
    }

    debug(...args: any[]) {
        Rollbar.debug.apply(Rollbar, args);
    }

    active() {
        return this.available;
    }

}

export const rollbarLogger = new RollbarLogger();



// WEBPACK FOOTER //
// ./_src/services/logging/integrations/rollbarLogger.ts